<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
<!-- Hide corporation, env column as not needed -->
<re-process-list [columnsToIgnore]="['environment', 'corporation']" (loaded)="load($event)" (downloadData)="download($event)" title="Import Users to IDM" description=""></re-process-list>
